import React, { useState, useEffect } from "react";
import { useFont } from "../../contexts/FontContext/FontContext";
import styles from "./InfoSection.module.css";

const InfoSection = () => {
  const [isSectionOneVisible, setIsSectionOneVisible] = useState(false);
  const [visibleImageIndex, setVisibleImageIndex] = useState(-1); // Track the currently visible image
  const [isSectionTwoVisible, setIsSectionTwoVisible] = useState(false); 
  const [isSectionThreeVisible, setIsSectionThreeVisible] = useState(false); 
  const ecommerceImageDelay = 300;
  const [scrollHeights, setScrollHeights] = useState({sectionOne: 900, sectionTwo: 1350, sectionThree: 1800});  // State to track scroll heights
  const fontSchemes = useFont();    
  const fontFamilyOne = fontSchemes.scheme_one; 

  useEffect(() => {
    const updateScrollHeights = () => {
      if (window.innerWidth <= 481) { setScrollHeights({sectionOne: 1000, sectionTwo: 1300, sectionThree: 1650}); } //mobile
      else if (window.innerWidth > 481 && window.innerWidth <= 768) { setScrollHeights({sectionOne: 1000, sectionTwo: 1400, sectionThree: 1800}); }
      else { setScrollHeights({sectionOne: 900, sectionTwo: 1350, sectionThree: 1800}); } // Use default heights for larger screens
    };
    updateScrollHeights(); // Set initial scroll heights based on current screen size
    window.addEventListener("resize", updateScrollHeights); // Add resize event listener to update on screen size change
    return () => window.removeEventListener("resize", updateScrollHeights); // Cleanup event listener on unmount
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || window.pageYOffset;
      if (scrollPosition > scrollHeights.sectionOne && !isSectionOneVisible) { setIsSectionOneVisible(true); }
      if (scrollPosition > scrollHeights.sectionTwo && !isSectionTwoVisible) { setIsSectionTwoVisible(true); }
      if (scrollPosition > scrollHeights.sectionThree && !isSectionThreeVisible) { setIsSectionThreeVisible(true); }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollHeights, isSectionOneVisible, isSectionTwoVisible, isSectionThreeVisible]);

  // Sequentially fade in images for section one
  useEffect(() => {
    if (isSectionOneVisible) {
      const imageFadeInInterval = setInterval(() => { setVisibleImageIndex((prevIndex) => prevIndex + 1); }, ecommerceImageDelay); // Always increment based on previous value
      if (visibleImageIndex === 2) { clearInterval(imageFadeInInterval); } // Stop interval after all images are visible
      return () => clearInterval(imageFadeInInterval);
    }
  }, [isSectionOneVisible, visibleImageIndex]);

  return (
    <div className={styles.info_section}>
      <div className={`${styles.sections} ${styles.section_one}`}>
        <div className={`${styles.sub_sections} ${styles.section_one_left}`}>
          <img src={`${process.env.PUBLIC_URL}/images/shopify.png`} className={`${styles.section_one_images} ${styles.shopify_logo} ${visibleImageIndex >= 0 ? "fade_in_bounce" : ""}`} alt="shopify_logo" />
          <img src={`${process.env.PUBLIC_URL}/images/magento.png`} className={`${styles.section_one_images} ${styles.magento_logo} ${visibleImageIndex >= 1 ? "fade_in_bounce" : ""}`} alt="magento_logo" />
          <img src={`${process.env.PUBLIC_URL}/images/woo_commerce.png`} className={`${styles.section_one_images} ${styles.woo_commerce_logo} ${visibleImageIndex >= 2 ? "fade_in_bounce" : ""}`} alt="woo_commerce_logo" />
        </div>
        <div className={`${styles.sub_sections} ${styles.section_one_right}`}>
          <p className={`${styles.section_blurb} ${fontFamilyOne} ${isSectionOneVisible ? "fade_in_bounce" : ""}`}>Integrate your brand.</p>
        </div>
      </div>
      <div className={`${styles.sections} ${styles.section_two}`}>
        <div className={`${styles.sub_sections} ${styles.section_two_left}`}>
          <p className={`${styles.section_blurb} ${fontFamilyOne} ${isSectionTwoVisible ? "fade_in_bounce" : ""}`}>
            Create labels and manage returns.
          </p>
        </div>
        <div className={`${styles.sub_sections} ${styles.section_two_right}`}>
          <img src={`${process.env.PUBLIC_URL}/images/return_label.png`} className={`${isSectionTwoVisible ? styles.fade_in_from_right : ""} ${styles.section_two_image}`} alt="section_two_image" />
        </div>
      </div>
      <div className={`${styles.sections} ${styles.section_three}`}>
        <div className={`${styles.sub_sections} ${styles.section_three_left}`}>
          <img src={`${process.env.PUBLIC_URL}/images/time_and_money.png`} className={`${isSectionThreeVisible ? styles.fade_in_from_left : ""} ${styles.section_three_image}`} alt="section_three_image" />
        </div>
        <div className={`${styles.sub_sections} ${styles.section_three_right}`}>
          <p className={`${styles.section_blurb} ${fontFamilyOne} ${isSectionThreeVisible ? styles.fade_in_from_right : ""}`}>Save time and dollars.</p>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
